import { call } from 'redux-saga/effects';
import { APIHandler } from '../commonHandlers';

function* getTestRegistrations(api, action) {
  yield call(APIHandler, api, action);
}

function* getTestResults(api, action) {
  yield call(APIHandler, api, action);
}

function* getTestDetailInfo(api, action) {
  yield call(APIHandler, api, action);
}
export default {
  getTestRegistrations,
  getTestResults,
  getTestDetailInfo,
};
